import {
  apiClient,
  type MonthlyCustomerReportDateRangeDetailExEntity,
  type PageEntity
} from '@/libs/api'
import { type MonthlyCustomerReportDateRangeDetailsRequestQuery } from '@/libs/api/types'

export type FetchMonthlyCustomerReportDateRangeDetailsQuery = {
  tenantKey: string
  query: MonthlyCustomerReportDateRangeDetailsRequestQuery
}

export type FetchMonthlyCustomerReportDateRangeDetailsResponse = {
  data: MonthlyCustomerReportDateRangeDetailExEntity
  pagination: PageEntity | null
}

/**
 * 月次請求レポートの日付範囲明細を取得する (#4829)。
 * 範囲集計の一覧行 1 件（荷主）について、合計・月次追加請求・明細行（ページ分）を返す。
 */
export const fetchMonthlyCustomerReportDateRangeDetails = async (
  { tenantKey, query }: FetchMonthlyCustomerReportDateRangeDetailsQuery,
  signal?: AbortSignal
): Promise<FetchMonthlyCustomerReportDateRangeDetailsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .monthly_customer_reports.summary.details.$get({
      query,
      config: { signal }
    })
  return { data, pagination: pagination ?? null }
}
